import didInsert from '@ember/render-modifiers/modifiers/did-insert';

import perform from 'ember-concurrency/helpers/perform';
import t from 'ember-intl/helpers/t';

import FileUploader from 'umg-ember-backend/components/ui/file-uploader';
import Loader from 'umg-ember-backend/components/ui/loader';
import Window from 'umg-ember-backend/components/ui/window';

<template>
  <Window {{didInsert @controller.setHeadData}}>
    <:title>
      {{t 'tool_itunes_ids_uploader.headline'}}
    </:title>

    <:body>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <div class={{(@controller.bem)}}>
            <div class={{@controller.bem 'legend'}}>
              {{t 'tool_itunes_ids_uploader.details'}}
            </div>
            <div class={{@controller.bem 'content'}}>
              {{#if @controller.processUpload.isRunning}}
                <Loader
                  @isWaiting={{@controller.processUpload.isRunning}}
                  @isInline={{true}}
                  @message={{t 'tool_itunes_ids_uploader.processing'}}
                />
              {{else}}
                <FileUploader
                  @isMultiple={{false}}
                  @onSuccess={{perform @controller.processUpload}}
                />
              {{/if}}
            </div>
          </div>
        </div>
      </div>
    </:body>
  </Window>
</template>
